import Observer from '../utils/Observer'
class Parallax {
  _state = {
    current: 0,
    rafId: null,
    rafActive: false,
    windowHeight: 0,
    target: 0,
    landscapeHeight: 0,
    portraitHeight: 0,
    orientation: 'landscape',
    elements: [],
    isLoaded: false
  }

  options = {
    ease: 0.075,
    translateYMax: -200,
    mobileSize: 760,
    threshold: 200,
    heightDivider: 2
  }

  constructor(options = {}) {
    this._options = { ...options, ...Parallax.options }
    this._cacheSelectors()
    this._init()
    this._updateScroll = this._updateScroll.bind(this)
    this._setupAnimation = this._setupAnimation.bind(this)
  }

  _cacheSelectors() {
    this._elements = [...document.querySelectorAll('[data-parallax="true"]')]
    this._wrapper = document.querySelector('#wrapper')
    this._body = document.body
    this._html = document.documentElement
  }

  _init() {
    this._state.windowHeight = window.innerHeight
    this._addListeners()
    this._setupAnimation()
  }

  _addListeners() {
    //Check for firefox
    if ('MozAppearance' in this._html.style) {
      this._html.setAttribute('data-parallax', false)
    }
    //Change animation setup on resize
    window.addEventListener('resize', () =>
      window.requestAnimationFrame(this._setupAnimation)
    )
    window.addEventListener('scroll', () =>
      window.requestAnimationFrame(this._updateScroll)
    )
  }

  _offset = el => {
    const rect = el.getBoundingClientRect(),
      scrollTop = window.pageYOffset || document.documentElement.scrollTop
    return rect.top + scrollTop
  }

  /* eslint-disable no-invalid-this */
  _setupAnimation = () => {
    // Updating dimensions
    this._state.windowHeight = window.innerHeight
    this._elements.forEach(el => {
      //Get ease
      const ease = el.getAttribute('data-ease')

      //calculate endPosition
      const endPos = Math.round(
        (this._body.offsetHeight -
          this._state.windowHeight -
          this._state.windowHeight / this.options.heightDivider +
          el.offsetHeight) *
          ease
      )

      //Adjust element top position to cancel endPosition
      el.style.top =
        el.getAttribute('data-parallax-type') !== 'static' && `${-endPos}px`

      const startPos = this._offset(el)
      this._state.elements.push({
        currentPos: startPos,
        startPos,
        ease
      })
    })

    // Start the animation, if it is not running already
    this._updateAnimation()
  }

  // Update scroll `target`, and start the animation if it is not running already
  _updateScroll = () => {
    this._state.target = window.scrollY || window.pageYOffset
    this._updateAnimation()
  }

  //Update the animation for each element
  _updateAnimation = () => {
    this._elements.forEach((el, i) => {
      const pos = Math.round(
        (this._state.target -
          this._state.windowHeight / this.options.heightDivider +
          el.offsetHeight) *
          this._state.elements[i].ease
      )
      // Set the CSS `transform` corresponding to the custom scroll effect
      this._setTransform(el, `translate3d(0,${pos}px,0)`)
    })
    if (this._state.isLoaded) return
    // Trigger parallax ready once
    Observer.publish(this._wrapper, 'parallax_ready', true)
    this._state.isLoaded = true
  }
  /* eslint-enable */

  _setTransform = (el, transform) => {
    el.style.transform = transform
    el.style.WebkitTransform = transform
  }
}

export default Parallax
